import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useIntl } from 'react-intl';
import { StationAuditPage } from '../../components/StationAuditPage';
import { ScheduleStatusRootView } from './ScheduleStatusRootView';

export function StationScheduleStatusPage() {
  const station = useActiveStation();
  const { $t } = useIntl();

  return (
    <StationAuditPage
      title={$t({
        id: 'audit.scheduleStatusScreen.title',
        defaultMessage: 'Status',
      })}
    >
      <ScheduleStatusRootView station={station} />
    </StationAuditPage>
  );
}
